import { useFormik } from 'formik';
import * as Yup from 'yup';

export function useAssignedValidation(onSubmit) {
  const initialValues = {
    userEmail: '',
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      userEmail: Yup.string().required('El campo usuario es requerido'),
    }),
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit,
  });

  return formik;
}
